/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdSearchProps } from './type';

export const searchDefaultProps: TdSearchProps = {
  action: '',
  center: false,
  clearable: true,
  disabled: false,
  focus: false,
  leftIcon: 'search',
  placeholder: '',
  readonly: false,
  shape: 'square',
};
